/**
 * Formats a date string into a human-readable format (e.g. "Jan 1, 2023")
 * @param dateString - ISO date string to format
 * @returns Formatted date string, or empty string if no date provided
 */
export function formatDate(dateString?: string): string {
	if (!dateString) return ''

	const date = new Date(dateString)

	// Handle invalid dates
	if (Number.isNaN(date.getTime())) {
		return ''
	}

	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec'
	]

	const month = months[date.getMonth()]
	const day = date.getDate()
	const year = date.getFullYear()

	return `${month} ${day}, ${year}`
}
